import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const lastTimeRef = useRef(0);

  // 시간 형식 변환 함수
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  // 재생 함수
  const playVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  // 정지 함수
  const pauseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 비디오 메타 데이터가 로드된 후 호출되는 함수
    const handleLoadedMetadata = () => {
      setDuration(video.duration);
      lastTimeRef.current = video.currentTime;
    };

    // 사용자가 시킹(seek)하려고 시도할 때 재생 위치를 이전 시간으로 되돌립니다.
    const handleSeeking = () => {
      if (video.currentTime !== lastTimeRef.current) {
        video.currentTime = lastTimeRef.current;
      }
    };

    // 재생 시간 업데이트 시 마지막 시간을 갱신합니다.
    const handleTimeUpdate = () => {
      setCurrentTime(video.currentTime);
      lastTimeRef.current = video.currentTime;
    };

    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('seeking', handleSeeking);
    video.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('seeking', handleSeeking);
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, []);

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        fontFamily: 'Arial, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh'
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'center',
          padding: '10px',
          borderBottom: '1px solid #dee2e6'
        }}
      >
        <div
          className="logo"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src="/images/ulvac_logo.png"
            alt="ulvac_logo"
            style={{
              height: '40px',
              maxWidth: '100%'
            }}
          />
        </div>
      </header>

      {/* Video Container */}
      <div
        className="video-container"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#e9ecef',
          padding: '10px'
        }}
      >
        <video
          ref={videoRef}
          id="myVideo"
          width="600"
          height="400"
          playsInline
          style={{
            width: '100%',
            maxWidth: '1080px',
            height: 'auto'
          }}
        >
          <source src="https://visit.ulvackorea.co.kr/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div
          className="button-container"
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <button
            className="control-button"
            onClick={playVideo}
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              textAlign: 'center',
              textDecoration: 'none',
              display: 'inline-block',
              fontSize: '16px',
              margin: '5px',
              cursor: 'pointer',
              borderRadius: '5px',
              transition: 'background-color 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#45a049';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#4CAF50';
            }}
          >
            Play
          </button>
          <button
            className="control-button"
            onClick={pauseVideo}
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              textAlign: 'center',
              textDecoration: 'none',
              display: 'inline-block',
              fontSize: '16px',
              margin: '5px',
              cursor: 'pointer',
              borderRadius: '5px',
              transition: 'background-color 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#45a049';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#4CAF50';
            }}
          >
            Stop
          </button>
        </div>

        <div
          className="time-display"
          style={{
            marginTop: '10px',
            fontSize: '16px'
          }}
        >
          <span id="currentTime">{formatTime(currentTime)}</span> / <span id="duration">{formatTime(duration)}</span>
        </div>
      </div>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: '#f8f9fa',
          textAlign: 'center',
          padding: '10px',
          borderTop: '1px solid #dee2e6'
        }}
      >
        {/* Footer content can be added here if needed */}
      </footer>

      {/* Media Query Styles */}
      <style>
        {`
          @media (max-width: 768px) {
            .logo img {
              height: 30px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default VideoPlayer;
